export const ENCURRENCY = 'EGP'
export const ARCURRENCY = 'EGP'
export const SanadCurrency = 'EUR'
export const AbwabCurrency = 'EGP'
